import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-2 pb-2 text-left" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "mt-2 pb-2 text-left" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "mt-1" }
const _hoisted_13 = { class: "inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_14 = { class: "block truncate" }
const _hoisted_15 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_16 = { class: "mt-2 pb-2 text-left" }
const _hoisted_17 = { class: "text-sm" }
const _hoisted_18 = { class: "mt-1" }
const _hoisted_19 = { class: "w-full" }
const _hoisted_20 = { class: "mt-1" }
const _hoisted_21 = { class: "inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_22 = { class: "block truncate" }
const _hoisted_23 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_24 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }

import { computed, ref } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Listbox,
  ListboxLabel,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
import { translate } from "@/utils/tools";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawPaymentSwitchingFilterDialog',
  props: { form: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form"],
  setup(__props, { emit }) {

const props = __props

const SelectorIcon = require("@heroicons/vue/solid/SelectorIcon");
const CheckIcon = require("@heroicons/vue/solid/CheckIcon");
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const selectedOption = ref({ label: "-Select-", value: null });
const selectedChannelOption = ref({ label: "-Select-", value: null });
//   "WAITING_APPROVE" = "WAITING_APPROVE",
//   "REJECTED" = "REJECTED",
//   "PENDING" = "PENDING", //first attemp
//   "SUBMITED" = "SUBMITED",
//   "FAILED" = "FAILED",
//   "CALLBACK_SUCCEED" = "CALLBACK_SUCCEED",
//   "COMPLETED" = "COMPLETED"
let advanceFromOption = [
  {
    id: 0,
    value: ["REJECTED", "PENDING", "SUBMITTED", "FAILED", "CALLBACK_SUCCEED", "COMPLETED", "CALLBACK_FAILED", "APPROVING"],
    label: `-${translate("messages.withdrawTransaction.selected")}-`,
  },
  {
    id: 2,
    value: ["REJECTED"],
    label: "REJECTED",
  },
  {
    id: 3,
    value: ["PENDING"],
    label: "PENDING",
  },
  {
    id: 4,
    value: ["SUBMITTED"],
    label: "SUBMITTED",
  },
  {
    id: 4,
    value: ["FAILED"],
    label: "FAILED",
  },
  {
    id: 5,
    value: ["CALLBACK_SUCCEED"],
    label: "CALLBACK SUCCEED",
  },
  {
    id: 6,
    value: ["CALLBACK_FAILED"],
    label: "CALLBACK FAILED",
  },
  {
    id: 7,
    value: ["COMPLETED"],
    label: "COMPLETED",
  },
  {
    id: 8,
    value: ["APPROVING"],
    label: "APPROVING",
  },
];

let advanceFromChannelOption = [
  {
    id: 0,
    value: null,
    label: `-${translate("messages.withdrawTransaction.selected")}-`,
  },
  ...store.state.financeModuleCode.map((payment, index) => ({ id: index, value: payment, label: payment })),
  // {
  //   id: 1,
  //   value: "RTB",
  //   label: "RTB",
  // },
  // {
  //   id: 2,
  //   value: "POWERPG",
  //   label: "POWERPG",
  // },
  // {
  //   id: 3,
  //   value: "ZPAY",
  //   label: "ZPAY",
  // },
  // {
  //   id: 4,
  //   value: "BITPAYZ",
  //   label: "BITPAYZ",
  // },
  // {
  //   id: 5,
  //   value: "SWIFTPAY",
  //   label: "SWIFTPAY",
  // },
  // {
  //   id: 6,
  //   value: "AIPAY",
  //   label: "AIPAY",
  // },
  // {
  //   id: 7,
  //   value: "PAYONEX",
  //   label: "PAYONEX",
  // },
  // {
  //   id: 8,
  //   value: "UIPAY",
  //   label: "UIPAY",
  // },
  // {
  //   id: 9,
  //   value: "SUZAKU",
  //   label: "SUZAKU",
  // },
];





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[5] || (_cache[5] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("messages.withdrawTransaction.advanceFilter")), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.withdrawTransaction.userPhone")), 1),
                        _createElementVNode("div", _hoisted_7, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.form.user_phone) = $event)),
                            name: "username",
                            id: "username",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, __props.form.user_phone]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("messages.withdrawTransaction.status")), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_unref(Listbox), {
                              modelValue: selectedOption.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOption).value = $event))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                  _createVNode(_unref(ListboxButton), { class: "w-full py-2 pl-3 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_13, [
                                        _createElementVNode("span", _hoisted_14, _toDisplayString(selectedOption.value.label), 1),
                                        _createVNode(_unref(SelectorIcon), {
                                          class: "w-5 h-5 text-gray-400 ml-auto",
                                          "aria-hidden": "true"
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_Transition, {
                                    "leave-active-class": "transition duration-100 ease-in",
                                    "leave-from-class": "opacity-100",
                                    "leave-to-class": "opacity-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ListboxOptions), { class: "absolute w-10/12 max-h-60 mt-1 mx-2 py-1 z-100 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advanceFromOption), (option, index) => {
                                            return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                              key: index,
                                              value: option,
                                              as: "template"
                                            }, {
                                              default: _withCtx(({ active, selected }) => [
                                                _createElementVNode("li", {
                                                  class: _normalizeClass([
                                  active
                                    ? 'text-amber-900 bg-amber-100'
                                    : 'text-gray-900',
                                  'cursor-default select-none relative py-2 pl-10 pr-4',
                                ])
                                                }, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass([
                                    selected ? 'font-medium' : 'font-normal',
                                    'block truncate',
                                  ])
                                                  }, _toDisplayString(option.label), 3),
                                                  selected
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                                        _createVNode(_unref(CheckIcon), {
                                                          class: "w-5 h-5",
                                                          "aria-hidden": "true"
                                                        })
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 2)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("messages.withdrawTransaction.channel")), 1),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_unref(Listbox), {
                              modelValue: selectedChannelOption.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedChannelOption).value = $event))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_unref(ListboxButton), { class: "w-full py-2 pl-3 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_21, [
                                        _createElementVNode("span", _hoisted_22, _toDisplayString(selectedChannelOption.value.label), 1),
                                        _createVNode(_unref(SelectorIcon), {
                                          class: "w-5 h-5 text-gray-400 ml-auto",
                                          "aria-hidden": "true"
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_Transition, {
                                    "leave-active-class": "transition duration-100 ease-in",
                                    "leave-from-class": "opacity-100",
                                    "leave-to-class": "opacity-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ListboxOptions), { class: "absolute w-10/12 max-h-60 mt-1 mx-2 py-1 z-100 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advanceFromChannelOption), (option, index) => {
                                            return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                              key: index,
                                              value: option,
                                              as: "template"
                                            }, {
                                              default: _withCtx(({ active, selected }) => [
                                                _createElementVNode("li", {
                                                  class: _normalizeClass([
                                  active
                                    ? 'text-amber-900 bg-amber-100'
                                    : 'text-gray-900',
                                  'cursor-default select-none relative py-2 pl-10 pr-4',
                                ])
                                                }, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass([
                                    selected ? 'font-medium' : 'font-normal',
                                    'block truncate',
                                  ])
                                                  }, _toDisplayString(option.label), 3),
                                                  selected
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                                        _createVNode(_unref(CheckIcon), {
                                                          class: "w-5 h-5",
                                                          "aria-hidden": "true"
                                                        })
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 2)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (
                _ctx.$emit('submit', { flag: 1, chanel: selectedChannelOption.value.value, status: selectedOption.value.value })
                )),
                      class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                    }, " Filter "),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('submit'))),
                      class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                      ref: "cancelButtonRef"
                    }, " Cancel ", 512)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})